import { gtmPush } from "../../../helpers"

export function setCookie(cname: string, cvalue: string, exdays: number) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export type CookieStatus = 'accepted' | 'undecided'

export type CookieSettingsState = { cookieStatus: CookieStatus; unsubListener: () => void, error: boolean }

const cookiesAcceptedEvent = 'cookies_accepted'

export const getCookieStatus = (groupId: number): CookieStatus => {
  const cookiesCookie = getCookie('cookies')
  const OptanonConsentGroups = getOptanonConsentGroups()
  return (OptanonConsentGroups && groupId && OptanonConsentGroups[groupId]) || (cookiesCookie == 'accepted') ?
    'accepted' : 'undecided'
}

const getOptanonConsentGroups = () => {
  const OptanonConsent = parseCookie('OptanonConsent')
  if (OptanonConsent && OptanonConsent.groups) {
    return OptanonConsent.groups.split(/, */).reduce((obj, str) => {
      if (str === "") return obj;
      const eq = str.indexOf(':');
      const key = eq > 0 ? str.slice(0, eq) : str;
      let val = eq > 0 ? str.slice(eq + 1) : null;
      if (val != null) try { val = decodeURIComponent(val); } catch(ex) { /* pass */ }
      obj[key] = val == '1' ? true : false;
  
      return obj
    }, {})
  } else {
    return {}
  }
}


const parseCookie = (str) => {
  const c =  document.cookie.split(/; */).reduce((obj, str) => {
    if (str === "") return obj;
    const eq = str.indexOf('=');
    const key = eq > 0 ? str.slice(0, eq) : str;
    let val = eq > 0 ? str.slice(eq + 1) : null;
    if (val != null) try { val = decodeURIComponent(val); } catch(ex) { /* pass */ }
    obj[key] = val;
    return obj;
  }, {});

  return c[str] ? c[str].split(/& */).reduce((obj, str) => {
    if (str === "") return obj;
    const eq = str.indexOf('=');
    const key = eq > 0 ? str.slice(0, eq) : str;
    let val = eq > 0 ? str.slice(eq + 1) : null;
    if (val != null) try { val = decodeURIComponent(val); } catch(ex) { /* pass */ }
    obj[key] = val;
    return obj;

    }, {}) : {}
}

export const acceptCookies = () => {
  setCookie('cookies', 'accepted', 30)
  gtmPush({ category: 'Cookies', action: 'Accepted' })
  const event = new CustomEvent(cookiesAcceptedEvent)
  window.dispatchEvent(event)
}

export const updateCookieStatus = (s: CookieSettingsState): CookieSettingsState => ({
  ...s,
  cookieStatus: getCookieStatus(1),
})

export const addAcceptCookiesListener = (onCookiesAccepted: () => void): (() => void) => {
  window.addEventListener(cookiesAcceptedEvent, onCookiesAccepted)

  return () => window.removeEventListener(cookiesAcceptedEvent, onCookiesAccepted)
}